import { collapsedListsState } from './collapsedListsState';

export const expandAllListsOnBoard = (boardId: string) => {
  collapsedListsState.setValue((state) => {
    delete state[boardId];
    return state;
  });
};
